import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotVideo = ({
    spotColor = "#C6F4EC",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <path
            fill={spotColor}
            d="M7.394 27.594c.742 3.196 1.607 7.252 3.878 8.798 2.297 1.572 6.028.66 8.778-1.118 2.75-1.753 4.519-4.348 6.69-6.429 2.17-2.08 4.768-3.621 6.617-6.14 1.823-2.49 2.924-5.933 2.719-9.584-.205-3.651-1.717-7.51-4.7-8.207-2.982-.67-7.41 1.795-10.774 2.778-3.39.982-5.666.48-9.11.185C8.05 7.58 3.466 7.492 2.258 9.5c-1.21 1.983.932 6.064 2.352 9.273 1.394 3.235 2.015 5.598 2.785 8.82Z"
        />
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={strokeWidth}
            d="M28.57 17.45v-6.021c0-1.973-1.492-3.572-3.333-3.572H6.904c-1.841 0-3.334 1.6-3.334 3.572v17.857c0 1.972 1.493 3.571 3.334 3.571h18.333c1.84 0 3.333-1.599 3.333-3.571v-6.734m0-5.102 4.933-3.524c1.324-.945 3.163.001 3.163 1.628v8.894c0 1.626-1.84 2.573-3.163 1.627l-4.933-3.523m0-5.102v5.102"
        />
    </SVG>
);
SpotVideo.displayName = "SpotVideo";
